<ion-icon
  [name]="iconName"
  [color]="iconColor"
  [style.font-size]="iconSize">
</ion-icon>

<h2>{{ message | translate }}</h2>

<ion-button
  class="ion-padding"
  expand="block"
  [color]="buttonColor"
  (click)="close()">
  {{ buttonText | translate }}
</ion-button>